import * as React from "react";
import { IconFile } from "../icons";

function ZeroNodes({ message }: { message: string }) {
  return (
    <div className="border border-dashed border-stroke-base p-4 w-[500px] mx-auto mt-12 flex gap-4">
      <IconFile size={48} className="text-gray-600" />
      <div>
        <div className="font-bold">Готов к твоему первому документу</div>
        <br />
        <div>{message}</div>
      </div>
    </div>
  );
}

export function HubZeroNodes() {
  return <ZeroNodes message="Your team's central hub for sharing documents, images, videos, and files. Click 'Add' to get started." />;
}

export function FolderZeroNodes() {
  return <ZeroNodes message="This folder is empty. Click 'Add' to upload your first file." />;
}
